import ODataTokenGeneratorViewModelT from '@/Components/OData/ODataTokenGeneratorViewModel';
import ODataTokenGeneratorViewT from '@/Components/OData/ODataTokenGeneratorView';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
import { IViewFactoryConstructorParameter } from '#/CoreFrameInterfaces';

export default class ODataTokenGeneratorViewFactory extends ViewFactory {
    public viewModel: ODataTokenGeneratorViewModelT;
    public view: ODataTokenGeneratorViewT;
    private ODataTokenGeneratorViewModel = ComponentManager.getViewModel<typeof ODataTokenGeneratorViewModelT>('ODataTokenGenerator');
    private ODataTokenGeneratorView = ComponentManager.getView<typeof ODataTokenGeneratorViewT>('ODataTokenGenerator');
 
    constructor(protected params: IViewFactoryConstructorParameter) {
        super(params);
    }
    
    public getRegion(): string {
        return 'Modal';
    }
    
    public getView(): JQuery {
        if (this.viewModel == null) {
            this.viewModel = new this.ODataTokenGeneratorViewModel({ viewFactory: this });
        }
       
        if (this.view == null) {
            this.view = new this.ODataTokenGeneratorView(this.viewModel, this.createRootElement('ODataTokenGenerator'));
        }
        
        let tuple = this.view.getTuple();
        return tuple.view;
    }
}

ComponentManager.setFactory('ODataTokenGenerator', ODataTokenGeneratorViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');